import prepareOptions from '../../prepareOptions';

export default prepareOptions([
  {
    value: { min: '2', max: '2' },
    label: '2',
  },
  {
    value: { min: '2' },
    label: `${__('global.atleastCount')} 2`,
  },
  {
    value: { min: '3' },
    label: `${__('global.atleastCount')} 3`,
  },
  {
    value: { min: '4' },
    label: `${__('global.atleastCount')} 4`,
  },
  {
    value: { min: '5' },
    label: `${__('global.atleastCount')} 5`,
  },
  {
    value: { min: '6' },
    label: `${__('global.atleastCount')} 6`,
  },
]);
